import * as React from "react";
import NotFoundPage from "pages/NotFoundPage";
import useAgentWorkflowsLicensed from "aiagent/hooks/useAgentWorkflowsLicensed";
const withAgentWorkflowsLicense = (Component) => {
  var _a;
  const LicensedComponent = () => {
    const isLicensed = useAgentWorkflowsLicensed();
    return isLicensed ? /* @__PURE__ */ React.createElement(Component, null) : /* @__PURE__ */ React.createElement(NotFoundPage, { displayPageLayout: false });
  };
  LicensedComponent.displayName = `withAgentWorkflowsLicense(${(_a = Component.displayName) != null ? _a : Component.name})`;
  return LicensedComponent;
};
export default withAgentWorkflowsLicense;
